import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Title, Button } from '@qonsoll/react-design'
import { MAX_LENGTH_FIELD, MAX_LENGTH_DESCRIPTION, KEYS } from '__constants__'
import { Form, Input, InputNumber } from 'antd'

const OfferSimpleForm = (props) => {
  const { initialValues, onSubmit, onCancel, showTitle, form, group } = props

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const [baseForm] = Form.useForm()

  // [COMPUTED_PROPERTIES]
  const usedForm = form || baseForm

  // [HANDLERS]
  const handleCancel = () => {
    usedForm.resetFields()
    onCancel?.()
  }
  const handleKeyPress = (e) => {
    if (e.key === KEYS.ENTER) {
      e.preventDefault()
      e.stopPropagation()
      usedForm?.submit()
    }
  }

  return group ? (
    <>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Offer')}
        </Title>
      )}
      <Form.Item
        label={t('Payment terms')}
        name={[...group, 'paymentTerms']}
        rules={[
          {
            required: false,
            message: t('Please enter your offer payment terms!')
          },
          {
            max: MAX_LENGTH_FIELD,
            message: t('offer payment terms is too long!')
          }
        ]}>
        <Input
          placeholder={t('Please enter your offer payment terms')}
          onPressEnter={onSubmit}
        />
      </Form.Item>
      <Form.Item
        label={t('Price')}
        name={[...group, 'price']}
        rules={[
          {
            required: false,
            message: t('Please enter your offer price!')
          }
        ]}>
        <InputNumber placeholder={t('Please enter your offer price')} />
      </Form.Item>
      <Form.Item
        label={t('Data base id')}
        name={[...group, 'dataBaseId']}
        rules={[
          {
            required: false,
            message: t('Please enter your offer data base id!')
          },
          {
            max: MAX_LENGTH_FIELD,
            message: t('offer data base id is too long!')
          }
        ]}>
        <Input placeholder={t('Please enter your offer data base id')} />
      </Form.Item>
    </>
  ) : (
    <Form
      form={usedForm}
      initialValues={initialValues}
      onFinish={onSubmit}
      layout="vertical"
      onKeyPress={handleKeyPress}
      autoComplete="off">
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Offer')}
        </Title>
      )}
      <Form.Item
        label={t('Payment terms')}
        name="paymentTerms"
        rules={[
          {
            required: false,
            message: t('Please enter your offer payment terms!')
          },
          {
            max: MAX_LENGTH_FIELD,
            message: t('offer payment terms is too long!')
          }
        ]}>
        <Input placeholder={t('Please enter your offer payment terms')} />
      </Form.Item>
      <Form.Item
        label={t('Price')}
        name="price"
        rules={[
          {
            required: false,
            message: t('Please enter your offer price!')
          }
        ]}>
        <InputNumber placeholder={t('Please enter your offer price')} />
      </Form.Item>
      <Form.Item
        label={t('Data base id')}
        name="dataBaseId"
        rules={[
          {
            required: false,
            message: t('Please enter your offer data base id!')
          },
          {
            max: MAX_LENGTH_FIELD,
            message: t('offer data base id is too long!')
          }
        ]}>
        <Input placeholder={t('Please enter your offer data base id')} />
      </Form.Item>
      {!form && (
        <>
          <Button mr={2} htmlType="button" onClick={handleCancel}>
            {t('Cancel')}
          </Button>
          <Button type="primary" onClick={() => usedForm.submit()}>
            {t('Save')}
          </Button>
        </>
      )}
    </Form>
  )
}

OfferSimpleForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  showTitle: PropTypes.bool,
  form: PropTypes.any,
  group: PropTypes.array
}

export default OfferSimpleForm
